import React, { useEffect, useState } from 'react';
import {
  AMM_COOKIE_POLICY_URL,
  AMM_PRIVACY_URL,
  hasNumerologyCookieConsent,
  setNumerologyCookieConsent,
} from '../../data/numerologyLegalLinks';
import './NumerologyLegalShell.css';

export default function NumerologyCookieBanner() {
  const [visible, setVisible] = useState(() => !hasNumerologyCookieConsent());

  useEffect(() => {
    document.documentElement.setAttribute('data-numerology-cookie', visible ? 'open' : 'closed');
    return () => {
      document.documentElement.removeAttribute('data-numerology-cookie');
    };
  }, [visible]);

  const accept = () => {
    setNumerologyCookieConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="amm-num-cookie-banner" role="dialog" aria-label="Cookie consent" aria-live="polite">
      <div className="amm-num-cookie-banner__inner">
        <p className="amm-num-cookie-banner__text">
          We use cookies to improve experience, analytics, and marketing. By continuing, you agree to our{' '}
          <a href={AMM_PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="amm-num-cookie-banner__inline">
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href={AMM_COOKIE_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="amm-num-cookie-banner__inline"
          >
            Cookie Policy
          </a>
          .
        </p>
        <div className="amm-num-cookie-banner__actions">
          <button type="button" className="amm-num-cookie-banner__accept amm-button" onClick={accept}>
            Accept
          </button>
          <a
            href={AMM_COOKIE_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="amm-num-cookie-banner__learn amm-button-secondary"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
  );
}
